<!-- <div *ngIf="showFormLoader" class="loading-container">
  <app-loader [loaded]="false"></app-loader>
  <div class="loading-text">Loading form data...</div>
</div> -->

<!-- Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa" 
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px; cursor: pointer;" 
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Body with tabs following F7004 pattern -->
<div class="modal-body" [hidden]="minimise">
  <ul class="nav nav-pills" role="tablist">
    @for (tab of tabs; track $index) {
<li [class.active]="tab.id === activeTab">
      <a (click)="activeTab = tab.id" style="cursor: pointer;" class="btn-sm">
        {{ tab.name }}
      </a>
    </li>
}
  </ul>

  <div class="tab-content">
    <!-- Form Entry Tab -->
    @if (activeTab === 1) {
<div class="tab-pane active" style="overflow-y: auto; max-height: calc(90vh - 200px);">
      <div class="form-horizontal">
        @if (showFormLoader) {
<div class="formLoader">
          <i class="fa fa-spinner fa-spin gt-refresh"></i>
        </div>
}
        
        @if (!showFormLoader) {
<div>

        <!-- Entity information table -->
        <table class="table table-bordered form-inline enityDetails custom-table">
          <tr>
            @for (item of entityList; track $index) {
<td>
              <span>{{ item.key }}</span>
            </td>
}
          </tr>
          <tr>
            @for (item of entityList; track $index) {
<td>
              <span>{{ item.value }}</span>
            </td>
}
          </tr>
        </table>
        
  <!-- Tab Container (maintaining AngularJS structure) -->
  <div class="tab-container">
    


    <!-- Tab Content -->
    <div class="tab-content">
      
      <!-- Form Entry Tab -->
      <div class="tab-pane" [class.active]="activeTab === 1">
        
        <!-- Header Table Section -->
        @if (tableHeader && tableHeader.length > 0) {
<div class="header-table-section">
          <table class="table table-bordered form-inline custom-table">
            <tr>
              @if (tableHeader && tableHeader[0]) {
<td>{{tableHeader[0].description}}:
                <div>
                  <input
                    class="form-control input-md numText text_field_width"
                    type="text"
                    maxlength="19"
                    [(ngModel)]="tableHeader[0].value"
                    disabled
                    aria-describedby="basic-addon2">
                </div>
              </td>
}
              @if (tableHeader && tableHeader.length > 1) {
<td>{{tableHeader[1].description}}:
                <div>
                  <input
                    class="form-control input-md numText text_field_width"
                    type="text"
                    maxlength="10"
                    [(ngModel)]="tableHeader[1].value"
                    disabled
                    aria-describedby="basic-addon2">
                </div>
              </td>
}
            </tr>
          </table>
        </div>
}

        <!-- Main Form Table -->
        <div class="form-table-section">
          <div class="table-scroll">
            <table class="I_Entry table table-bordered form-inline customTable table-custom-bg custom-table">
              <thead>
                <tr>
                  <th colspan="10">{{modalTitle}}</th>
                </tr>
              </thead>
              <tbody>
                @for (row of scheduleBFormView; track itemTracker(i, row); let i = $index) {
<tr 
                  class="formDataBlock" 
                 >
                  
                  <!-- Line Number -->
                  <td>{{row.num}}</td>
                  
                  <!-- Description -->
                  <td class="descBlock">
                    <span>{{row.description}}</span>
                  </td>
                  
                  <!-- Yes/No Radio Buttons -->
                  <td align="right">
                    @if (row.edit_type === 'radio') {
<div>
                      <span>Yes </span>
                      <input 
                        type="radio" 
                        [name]="'radio_' + i + '_' + row.num" 
                        [value]="true"
                        [checked]="row.value === true"
                        (change)="onRadioChange(i, true, row)">
                      
                      <span style="margin-left: 4px;">No </span>
                      <input 
                        type="radio" 
                        [name]="'radio_' + i + '_' + row.num" 
                        [value]="false"
                        [checked]="row.value === false"
                        (change)="onRadioChange(i, false, row)">
                    </div>
}
                  </td>
                </tr>
}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

        </div>
}
      </div>
    </div>
}
  </div>
</div>

<!-- Footer for modal -->
<div class="modal-footer" [hidden]="minimise">
  @if (currentTabName != 'Subsidiary') {
<button 
          class="save-button" 
          type="button" 
          [disabled]="isSaveClicked" 
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save and Proceed
  </button>
}
  @if (currentTabName != 'Subsidiary') {
<button 
          class="reset-button" 
          type="button" 
          (click)="reset()">Reset</button>
}
  <button class="cancel-button" 
          type="button" 
          (click)="cancel()">Cancel</button>
</div>